import { Component, Output, EventEmitter,
  Input, ViewEncapsulation } from '@angular/core';
import { environment } from 'environments/environment';
import { SharedService } from '../../services/core/shared.service';
import { Router } from '@angular/router';
import { LabUserMenuService } from 'app/services/lab-user-menu/lab-user-menu.service';
import { AccountService } from 'app/services/account/account.service';
import { SettingsService } from 'app/services/core/settings.service';
import { AuthService } from '@shared/auth/auth.service';

@Component({
  selector: 'app-navbar',
  host: {
    class: 'matero-header',
  },
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class NavbarComponent{
  public environment = environment;

  public name: string = '';
  options = this.settings.getOptions();
  darkMode: boolean = this.options.theme === 'dark';
  @Input() isMobile = false;
  @Input() showToggle = true;
  @Output() toggleSidenav = new EventEmitter<void>();
  @Output() toggleChatbotNotice = new EventEmitter<void>();
  @Output() optionsChange = new EventEmitter<object>();

  constructor(private settings: SettingsService,
              private sharedService: SharedService,
              private router: Router,
              private service: LabUserMenuService,
              private logoutService: AccountService,
              private authService: AuthService
              ) { 
    // this.authService.currentUserEvent.subscribe(() => {
    //   this.sharedService.updateMenu();
    //   // Trigger change detection or any other necessary updates when the user information is loaded
    // });
  }
  
  toggleTheme() {
    this.darkMode = !this.darkMode;
    this.options.theme = this.darkMode ? 'dark' : 'light';
    this.settings.setTheme(this.options.theme);
    this.optionsChange.emit(this.options);
  }

  getUserName(): string {
    return sessionStorage.getItem('user');
  }

  authenticated(): boolean {
    return this.sharedService.userAuthenticated();
  }

  // logout(): void {
  //   this.logoutService.logout().subscribe(
  //     (result) => {
  //     },
  //     error => {
  //       console.log('error: ', error);
  //     }
  //   );
  //   // this.logoutService.logout();
  //   this.service.labFilter = "";
  //   // this.sharedService.logout();
  //   this.router.navigateByUrl("/");
  // }
}
